import React from "react";

const RemoveFromFavoriteIcon = (props) => {
	return props.removeFromFav ? (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			{...props}>
			<g opacity="0.5">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M2.77216 13.3289C0.409282 10.966 0.40928 7.13503 2.77216 4.77216C5.13503 2.40928 8.96601 2.40928 11.3289 4.77216L11.7349 5.17817C11.8814 5.32462 12.1188 5.32462 12.2652 5.17817L12.6712 4.77224C15.034 2.40936 18.865 2.40936 21.2279 4.77223C23.5908 7.13511 23.5908 10.9661 21.2279 13.329L12.0631 22.4938L12 22.4307L11.937 22.4937L2.77216 13.3289ZM7.99994 12.2501C7.58572 12.2501 7.24994 12.5859 7.24994 13.0001C7.24994 13.4143 7.58572 13.7501 7.99994 13.7501H15.9999C16.4142 13.7501 16.7499 13.4143 16.7499 13.0001C16.7499 12.5859 16.4142 12.2501 15.9999 12.2501H7.99994Z"
					fill="url(#paint0_linear_4550_47365)"
				/>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_4550_47365"
					x1="12"
					y1="3"
					x2="12"
					y2="22.4938"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#F0052F" />
					<stop
						offset="1"
						stopColor="#940136"
					/>
				</linearGradient>
			</defs>
		</svg>
	) : (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			{...props}>
			<path
				d="M2.77216 4.77216C0.40928 7.13503 0.409282 10.966 2.77216 13.3289L11.937 22.4937L12 22.4307L12.0631 22.4938L21.2279 13.329C23.5908 10.9661 23.5908 7.13511 21.2279 4.77223C18.865 2.40936 15.034 2.40936 12.6712 4.77224L12.2652 5.17817C12.1188 5.32462 11.8814 5.32462 11.7349 5.17817L11.3289 4.77216C8.96601 2.40928 5.13503 2.40928 2.77216 4.77216Z"
				fill="url(#paint0_linear_1977_529039)"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_1977_529039"
					x1="12"
					y1="3"
					x2="12"
					y2="22.4938"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#F0052F" />
					<stop
						offset="1"
						stopColor="#940136"
					/>
				</linearGradient>
			</defs>
		</svg>
	);
};

export default RemoveFromFavoriteIcon;
